var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.progress === true)?_c('i',{staticClass:"fa fa-check green"}):(_vm.progress === false)?_c('i',{staticClass:"fa fa-remove red"}):(_vm.progress === null)?_c('i',{staticClass:"fa fa-clock orange"}):_c('span',[_vm._v(_vm._s(_vm.progress))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18866110","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Pbn/Single/Tabs/PageEntity/ProgressBar.vue
// module id = null
// module chunks = 